/* eslint-disable no-undef */
/* eslint-disable no-useless-escape */
import React from "react";
import PropTypes from "prop-types"; // Import PropTypes
import { base_path, bucketObj } from "../../environment";
import axios from "axios";
// import crypto from 'crypto-browserify';
// const crypto = require('crypto')
const AWS = require('aws-sdk')
import { getUrls } from "../../api/apiurls";


let s3 = new AWS.S3()
var bucketName = ''

// const msPerMinute = 60 * 1000;
// const msPerHour = msPerMinute * 60;
// const msPerDay = msPerHour * 24;
// const msPerMonth = msPerDay * 30;
const configure = () => {
  bucketName = 'public-upload-stg'
  var accessKeyId = 'AKIAXWQHQYREAJI2RFGB'
  var secretAccessKey = '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'
  // if(!isSandbox){
  //   bucketName = "public-upload-live"
  //   accessKeyId = 'AKIAXWQHQYREEDRFWLWQ'
  //   secretAccessKey = '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'
     
  // }
  AWS.config.update({
    accessKeyId: accessKeyId,
    secretAccessKey,
    region: 'ap-northeast-1'
  })
  s3 = new AWS.S3()
}
configure(true)
export async function uploadFile2(file, type) {
  
  // const options = {
  //   maxSizeMB: 1,
  //   maxWidthOrHeight: 1920,
  //   useWebWorker: true
  // }
  var newFile = file;
  // console.log(`originalFile size ${file.size / 1024 / 1024} MB`);
  // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
  // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
  var fileName = "image_" + newFileName() + file.name
  const upload = new AWS.S3.ManagedUpload({
    params: {
      Bucket: bucketName,
      Key: type + fileName,
      Body: newFile
    }
  })
  await upload.promise()

  return fileName
}

export async function getImage(name) {
  let resp2 = await axios.get(`${getUrls().sso}/api/getUploadedContentUrl?filename=${name}`)
//  resp2.data.response.url = resp2.data?.response?.url.replace("https", "http");
  resp2.data.response.url = resp2.data?.response?.url.replace(/^https/, "http");
  let resp3 = await axios.get(resp2.data?.response?.url, {
    headers: {
      'Skip-Auth': 'true'
    }
  });
  return resp3.data;
}

export async function getImageURL(name) {
  let resp2 = await axios.get(`${getUrls().sso}/api/getUploadedContentUrl?filename=${name}`)
  let resp3 = await axios.get(resp2.data?.response?.url, {
    headers: {
      'Skip-Auth': 'true'
    }
  })
  return resp3.data;
}
function uniqueString({ length, userId, tenantId, name, platform, app, module }) {
  const mergeStringsRandomly = (str1, str2) => {
    const currentDate = new Date().toLocaleString(); // Get current date/time as a string
    const arr1 = Array.from(str1.replace(/[ :\/,]/g, '')); // Convert string 1 to array of characters, excluding spaces, colons, slashes, and commas
    const arr2 = Array.from(str2.replace(/[ :\/,]/g, '')); // Convert string 2 to array of characters, excluding spaces, colons, slashes, and commas
    const arrDate = Array.from(currentDate.replace(/[ :\/,]/g, '')); // Convert current date/time string to array of characters, excluding spaces, colons, slashes, and commas
    const combinedArray = arr1.concat(arr2).concat(arrDate);

    function shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }

    const shuffledArray = shuffleArray(combinedArray);
    const mergedString = shuffledArray.join('');
    return mergedString;
  };

  length = length || 15;
  name = name ? `_${name}` : '';

  platform = platform || 'inventory/';
  app = app ? `${app}/` : '';
  module = module ? `${module}/` : '';

  module = tenantId ? `${module}${tenantId}/` : '';
  module = userId ? `${module}${userId}/` : '';

  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    randomString += charset[randomIndex];
  }

  if (userId && tenantId) {
    let s1 = mergeStringsRandomly(userId, tenantId);
    randomString = mergeStringsRandomly(s1, randomString);
  }

  return `${platform}${app}${module}${randomString}${name}`;
}
export async function uploadImageNew(file) {
  if (!file) {
    alert('Please select a file.');
    return;
  }
  const randomString = uniqueString({length: 10, userId: '', tenantId: '', name: file.name, platform: '', app: 'web', module: 'sooqista'})
  const objectKey = bucketObj.objectKey + randomString; // Specify the path within the bucket (optional)
  const uploadUrl = `${bucketObj.bucketUrl}${objectKey}`;
  try {
    const uploadResponse = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      }
    });

    if (uploadResponse.ok) {
      console.log('File uploaded successfully', randomString );
      return randomString
    } else {
      console.error('Error uploading file:', uploadResponse.statusText);
    }
  } catch (error) {
    console.error('Error:', error);
  }
}
export async function uploadImage(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
      
    reader.onload = async (event) => {
      try {
        // let name = "stokifyImages" + newFileName(12);
        // const body = new FormData();
        // body.append("file", new Blob([event.target.result]), name);
        // await axios.put(`${getUrls().sso}/api/uploadContent`, body )
        // resolve(name);
        const extension = file.name.split('.').pop(); // Get file extension
        const name = `stokifyImages_${newFileName(12)}.${extension}`; // Include extension in the name
        const body = new FormData();
        body.append("file", new Blob([event.target.result], { type: file.type }), name); // Ensure MIME type is correct
        
        await axios.put(`${getUrls().sso}/api/uploadContent`, body);
        resolve(name);

      } catch(e) {
        reject(e);
      }
    };
    reader.readAsDataURL(file);  
  })
  
  
}

var newFileName = function(L) { 
  var length = L || 5
  var s = '';
  var randomchar = function() {
    var n = Math.floor(Math.random() * 62);
    if (n < 10) return n; //1-10
    if (n < 36) return String.fromCharCode(n + 55); //A-Z
    return String.fromCharCode(n + 61); //a-z
  }
  while (s.length < length) s += randomchar();
  return s + (0|Math.random()*9e6).toString(36)
 }

const ImageWithBasePath = (props) => {
  // Combine the base path and the provided src to create the full image source URL
  let fullSrc;
  if(props.absolutePath) {
    fullSrc = `${props.src}`;
  } else {
    fullSrc = `${base_path}${props.src}`;
  }
  return (
    <img
      className={props.className}
      src={fullSrc}
      height={props.height}
      alt={props.alt}
      width={props.width}
      id={props.id}
    />
  );
};

// Add PropTypes validation
ImageWithBasePath.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired, // Make 'src' required
  alt: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  id: PropTypes.string,
  absolutePath: PropTypes.string,
};
export const bucket = {
  s3
};
export default ImageWithBasePath;